import Svg from '@doordash/component-svg'
import * as React from 'react'

export const DollarBills: React.FC<{
  width?: number
  height?: number
  color?: string
}> = ({ width = 72, height = 72, color = 'none' }) => (
  <Svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill={color}
  >
    <path
      opacity={0.8}
      d="M71.067 29.72c.033 1.655-.806 9.12-1.027 10.367-.223 1.245-.844 7.216-1.073 8.214-.227.998-.672 7.027-1.076 7.968-.197.459-2.563.136-4.559-.321-1.994-.455-15.093-1.508-20.811-1.886-5.718-.379-25.862-1.95-27.852-2.155-1.99-.208-1.575-.133-1.388-3.117.186-2.983.673-19.463.901-20.46.227-.999 10.646-1.462 15.877-.577 5.233.886 31.219.845 34.038 1.118 2.82.273 6.97.849 6.97.849z"
      fill="#5BB55F"
    />
    <path
      d="M19.633 31.746s1.97-.946 2.146-2.344c.176-1.399-.43-2.268-.43-2.268s12.126.974 15.433 1.111c3.31.137 11.928 1.458 13.574 1.65 1.645.193 10.388.42 10.802.448.413.027 4.246.223 4.246.223s.25 1.918.829 2.663c1.221 1.574 2.526 1.498 2.686 1.592.161.093-.596 5.672-.697 6.962-.066.828-.732 4.76-.99 6.154-.212 1.141-.302 4-.302 4s-1.533-1.147-2.987-.496c-1.452.649-1.653 1.424-1.89 2.487-.795.298-6.37-.356-12.554-.782-6.698-.461-14.28-1.047-17.1-1.407-5.428-.694-12.24-.896-12.24-.896s-.072-2.328-.995-3.384c-1.387-1.584-3.484-.994-3.484-.994s.658-5.543.696-7.365c.04-1.822 1.242-6.99 1.242-6.99l2.015-.364z"
      fill="#AAD7AE"
    />
    <path
      opacity={0.8}
      d="M34.658 40.3c.064-1.526.77-3.118 1.89-4.536.785-.993 1.895-1.515 3.035-1.96 1.02-.4 2.082-.736 3.186-.678 3.507.183 6.436 1.012 8.039 4.864 1.038 2.492.925 5.014-.448 7.396-1.22 2.116-3.216 3.165-5.465 3.809-2.276.65-4.471.323-6.548-.742-1.062-.545-1.88-1.407-2.473-2.442-.958-1.67-1.363-3.48-1.216-5.711z"
      fill="#5BB55F"
    />
    <path
      d="M22.006 37.557c.736-1.015.895-1.206 1.932-1.641 1.067-.448 2.634-.891 3.535-.12.797.683 1.441 1.472 1.836 2.436.744 1.82.276 3.771-1.139 5.014-1.51 1.325-3.174 1.447-5.02.893-1.37-.411-1.88-1.395-2.033-2.682-.12-1.005.045-1.982.389-2.924.142-.386.376-.738.5-.976z"
      fill="#5BB55F"
    />
    <path
      opacity={0.8}
      d="M63.672 40.78c.434.838.61 1.839.451 2.884-.172 1.142-.79 1.983-1.838 2.47-1.74.807-3.463.868-5.128-.21-.607-.393-1.102-.901-1.4-1.57a2.728 2.728 0 01-.225-1.145c.015-1.137.196-2.243.771-3.247a3.177 3.177 0 011.933-1.508c1.865-.544 3.828-.067 5.012 1.565.15.207.243.44.424.761z"
      fill="#5BB55F"
    />
    <path
      d="M.635 19.82c.194 1.477 1.96 13.012 2.347 15.965.389 2.953-.429 10.07 1.294 9.844 1.723-.227 5.906-.776 10.401-.864 4.495-.09 19.261-2.031 22.707-2.483 3.446-.454 20.18-2.652 20.18-2.652s-.204-12.99-.591-15.945c-.388-2.953-2.634-12.422-2.634-12.422s-6.237 2.071-12.144 2.848c-5.907.776-20.343 1.42-24.74 2.247-4.398.83-17.013 1.986-16.82 3.462z"
      fill="#70B365"
    />
    <path
      d="M5.575 24.828c.538-.363 1.747-1.314 1.646-2.72-.101-1.406-.865-2.14-.865-2.14s12.082-1.42 15.352-1.933c3.27-.513 11.981-.906 13.633-1.04 1.651-.133 11.496-1.426 11.907-1.48.41-.054 2.98-.809 2.98-.809s.71 1.95 1.423 2.567c1.506 1.304 2.437.764 2.611.825.175.06.738 6.246.928 7.056.19.809.214 4.812.234 6.228.015 1.16.263 4.555.263 4.555s-1.976-1.077-3.273-.154c-1.299.921-1.498 1.95-1.521 3.037-.472.229-17.535 2.47-22.992 2.853-5.457.383-17.62 1.814-17.62 1.814s-.478-2.358-1.592-3.213c-1.67-1.283-3.585-.613-3.585-.613s.032-4.844-.288-6.639c-.318-1.794-1.144-7.444-1.144-7.444s1.366-.388 1.903-.75z"
      fill="#B2D6B0"
    />
    <path
      opacity={0.8}
      d="M20.1 29.529c-.261-1.669.16-3.546 1.067-5.327.635-1.246 1.725-2.053 2.865-2.782 1.02-.655 2.099-1.249 3.307-1.426 3.843-.561 7.198-.294 9.77 3.534 1.665 2.476 2.088 5.236 1.116 8.115-.864 2.559-2.802 4.128-5.101 5.314-2.327 1.198-4.777 1.318-7.26.612-1.269-.361-2.342-1.118-3.21-2.111-1.4-1.604-2.23-3.477-2.554-5.93zM12.693 27.724c1.25-.101 2.326-.023 3.332.48 1.034.52 1.563 1.34 1.563 2.525 0 1.05-.18 2.052-.655 2.979-.897 1.748-2.684 2.664-4.547 2.398-1.99-.283-3.165-1.469-3.946-3.23-.58-1.308-.165-2.335.713-3.289.686-.745 1.535-1.255 2.473-1.606.385-.146.806-.196 1.067-.257zM51.423 27.272c.136.935-.026 1.936-.518 2.872-.538 1.023-1.398 1.615-2.548 1.731-1.907.193-3.555-.315-4.776-1.878-.444-.57-.745-1.213-.806-1.942a2.713 2.713 0 01.16-1.157c.389-1.068.922-2.054 1.794-2.813a3.175 3.175 0 012.32-.793c1.94.099 3.64 1.192 4.223 3.121.074.246.084.497.15.859z"
      fill="#5BB55F"
    />
  </Svg>
)

export default DollarBills
